export const PERSONA_EMAIL_DOMAIN = "persona.pax.invalid";

/** The Better Auth role Pax developers hold. Developers can act as other people. */
export const DEVELOPER_ROLE = "developer";

/** The Better Auth role of a player an eval creates. Synthetic users never appear in Act as, search, or friends. */
export const SYNTHETIC_ROLE = "synthetic";

export const SYNTHETIC_EMAIL_DOMAIN = "synthetic.pax.invalid";

/**
 * The Better Auth role of a service account: something Pax runs or trusts, such as the seed, CI or
 * an AI agent, signed in with an API key rather than a person's provider account.
 */
export const SERVICE_ROLE = "service";

export const SERVICE_EMAIL_DOMAIN = "service.pax.invalid";

export function isPersonaEmail(email: string): boolean {
  return email.toLowerCase().endsWith(`@${PERSONA_EMAIL_DOMAIN}`);
}
